import React, { useEffect, useMemo, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { createRole, deleteRole, fetchAllRoles, updateRole, } from "../../../core/data/redux/user/role/roleAction";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { exportToCSV, exportToExcel, exportToPDF } from "../../../core/common/GlobalFunctions/exportTableData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { Button, Drawer, Form, Input, message, Select, Upload } from "antd";
import { status } from "../../../core/common/selectoption/selectoption";
import { formatDate } from "../../../core/utils/configFormatters";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { decryptData } from "../../../core/utils/encryptUtils";
import { createEmail, fetchAllEmail, updateMail , deleteMail } from "../../../core/data/redux/email_configuration/email.Action";
import Password from "antd/es/input/Password";


const Email_confriguration = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [selectedDataStatus, setSelectedDataStatus] = useState("All");
    const [selectedSort, setSelectedSort] = useState<any>("");
    const [tableKey, setTableKey] = useState(0);
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
    const [modalType, setModalType] = useState<"edit" | "create" | "">("");
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const [selectedStatus, setSelectedStatus] = useState<any>("");
    const [roleName, setRoleName] = useState<string>("");
    const { user } = useSelector((state: any) => state.auth);
    const { roles, loadingStates } = useSelector((state: any) => state.role);
    const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;
    const roleId = selectedRowData?.RoleId;
    const { createLoading } = useSelector((state: any) => state.companyDetails);
    const { companyDetails } = useSelector((state: any) => state.companyDetails);
    const { activeCompany } = useSelector((state: any) => state.companyDetails);
    const [tabledata, settabledata] = useState<any>([])

    useEffect(() => {
        dispatch(fetchAllEmail())
            .then((res) => {
                settabledata(res.payload.data)
            })
    }, [dispatch]);

    const [formData, setFormData] = useState<any>({
        email: "",
        description: "",
        status: "active",
        Password: ""
    });

    const [errors, setErrors] = useState<any>({
        email: "",
        Password: "",
        description: "",
        status: "",
    });

    const clearForm = () => {
        setFormData({
            email: "",
            password: "",
            description: "",
            status: "active",
        });
    };

    useEffect(() => {
        if (modalType === "edit" && selectedRowData) {
            const defaultFormData = {
                email: "",
                description: "",
                status: "active",
                Password: ""
            };

            const filledData = {
                email: selectedRowData.Email || "",
                description: selectedRowData.Description || "",
                status: selectedRowData.Status || "active",
                Password: selectedRowData.Password || ""
            };

            setFormData({ ...defaultFormData, ...filledData });
        }
    }, [modalType, selectedRowData]);



    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData((prev: any) => ({ ...prev, [name]: value }));
    };

    const handleStatusChange = (value: string) => {
        setFormData((prev: any) => ({ ...prev, status: value }));
    };

    const validateForm = () => {
        let formIsValid = true;
        let newErrors: any = {
            email: "",
            Password: "",
            description: "",
            status: "",
        };

       
        if (!formData.email || !formData.email.trim()) {
            formIsValid = false;
            newErrors.email = "Email is required.";
        } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
            formIsValid = false;
            newErrors.email = "Enter a valid email.";
        }

       
        if (!formData.Password || !formData.Password.trim()) {
            formIsValid = false;
            newErrors.Password = "Password is required.";
        } else if (formData.Password.length < 6) {
            formIsValid = false;
            newErrors.Password = "Password must be at least 6 characters long.";
        }

       
        if (formData.description && formData.description.trim().length > 0 && formData.description.length < 5) {
            formIsValid = false;
            newErrors.description = "Description should be at least 5 characters.";
        }

       
        if (!formData.status) {
            formIsValid = false;
            newErrors.status = "Status is required.";
        }

        setErrors(newErrors);
        return formIsValid;
    };



    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validateForm()) {


            if (modalType === "edit" && selectedRowData) {

                dispatch(updateMail({ data: formData, Id: selectedRowData.Id }))
                    .then((res: any) => {
                        message.success(res.payload.message);
                        setIsDrawerVisible(false)
                        dispatch(fetchAllEmail())
                            .then((res) => {
                                settabledata(res.payload.data)
                            })
                    })
                    .catch(() => {
                        message.error("Failed to update email configuration");
                    });
            } else {
                // Create Mode → Call create API
                dispatch(createEmail(formData))
                    .then((res: any) => {
                        message.success(res.payload.message);
                        setIsDrawerVisible(false)
                        dispatch(fetchAllEmail())
                            .then((res) => {
                                settabledata(res.payload.data)
                            })
                    })
                    .catch(() => {
                        message.error("Failed to create email configuration");
                    });
            }

            console.log("Form submitted");
        }
    };


    const encryptedPermissions = localStorage.getItem('currentPermissions');
    const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


    const canAdd =
        permissions.includes("Add") || permissions.includes("AllowAll");
    const canView =
        permissions.includes("View") || permissions.includes("AllowAll");
    const canEdit =
        permissions.includes("Edit") || permissions.includes("AllowAll");
    const canDelete =
        permissions.includes("Delete") || permissions.includes("AllowAll");

    useEffect(() => {
        if (modalType === "edit" && roleId) {
            setRoleName(selectedRowData?.RoleName);
            setSelectedStatus(selectedRowData?.Status);
        }
    }, [selectedRowData]);

    const resetFields = () => {
        setRoleName("");
        setSelectedStatus("");
        setSelectedRowData(null);
    };


    const showDrawer = (type: "edit" | "create") => {
        setModalType(type);
        setIsDrawerVisible(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerVisible(false);
        setModalType("");
        resetFields();
    };

    const handleEditDepartment = (record: any): void => {
        setSelectedRowData(record);
    };



    const handleDeleteRole = async (roleId: number) => {
        try {
            const result = await dispatch(deleteMail(roleId));
            if (result.meta.requestStatus === "fulfilled") {
                message.success(result.payload.message);
                setIsDeleteModalVisible(false);
                dispatch(fetchAllEmail())
                    .then((res) => {
                        settabledata(res.payload.data)
                    })
            } else {
                message.warning(result.payload.message);
            }
        } catch (error) {
            message.error("Something went wrong");
        }
    };

    const data = tabledata ? tabledata : [];

    const filteredData = useMemo(() => {
        const filters =
            selectedDataStatus && selectedDataStatus !== "All"
                ? { Status: selectedDataStatus }
                : {};
        return filterData(
            data || [],
            filters,
            "CreatedAt",
            "CreatedAt",
            selectedSort
        );
    }, [roles, selectedDataStatus, selectedSort, tabledata]);

    useEffect(() => {
        setTableKey((prevKey) => prevKey + 1);
    }, [selectedDataStatus, selectedSort, roles, tabledata]);

    const config = useAppConfig();
    if (!config) return null;

    const columns = [
        {
            title: "Email",
            dataIndex: "Email",
            sorter: (a: any, b: any) => a.Email.length - b.Email.length,
        },
        {
            title: "Description",
            dataIndex: "Description",
            sorter: (a: any, b: any) => a.Description.length - b.Description.length,
        },
        {
            title: "Status",
            dataIndex: "Status",
            render: (_: any, record: any) => {
                return <span style={{ color: 'green' }}>{record.Status}</span>;
            },
            sorter: (a: any, b: any) =>
                a.Status.length - b.Status.length,
        },
        {
            title: "Action",
            dataIndex: "actions",
            render: (text: string, record: any) => (
                <div className="action-icon d-inline-flex">
                    <button
                        className="me-2"
                        onClick={() => {
                            if (!canEdit) return;
                            showDrawer("edit");
                            handleEditDepartment(record);
                        }}
                        disabled={!canEdit}
                        style={{
                            cursor: canEdit ? "pointer" : "not-allowed",
                            opacity: canEdit ? 1 : 0.5,
                        }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Edit"
                    >
                        <i className="ti ti-edit" />
                    </button>
                    <button
                        className="me-2"
                        onClick={() => {
                            setIsDeleteModalVisible(true)
                            setSelectedRowData(record)
                        }}
                        style={{
                            cursor: "pointer",
                            opacity: 1,
                        }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Edit"
                    >
                        <i className="ti ti-trash" />
                    </button>
                </div>
            ),
        },
    ];

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Email </h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Administration</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Email Configuration
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="me-2 mb-2">
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="ti ti-file-export me-1" />
                                        Export
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <button
                                                onClick={() => exportToCSV(data, "email_configuration")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-pdf me-1" />
                                                Export as CSV
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                onClick={() => exportToExcel(data, "email_")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-xls me-1" />
                                                Export as Excel{" "}
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                onClick={() => exportToPDF(data, "email_")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-xls me-1" />
                                                Export as PDF{" "}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="mb-2">
                                <button
                                    onClick={() => {
                                        showDrawer("create");
                                        setErrors({});
                                        clearForm()
                                    }}
                                    className="btn btn-primary d-flex align-items-center"
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add Email
                                </button>
                            </div>
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Assets Lists */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Email List</h5>
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        {selectedSort
                                            ? `Sort By : ${selectedSort}`
                                            : "Sort By : Last 7 Days"}
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Recently Added")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Recently Added
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Ascending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Ascending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Descending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Descending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last Month")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last Month
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last 7 Days")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last 7 Days
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Table
                                key={tableKey}
                                dataSource={filteredData}
                                columns={columns}
                                Selection={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>
            <Drawer
                title={modalType === "edit" ? "Edit Email" : "Create Email"}
                placement="right"
                width={600}
                style={{ marginTop: 50 }}
                onClose={() => setIsDrawerVisible(false)}
                open={isDrawerVisible}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Form layout="vertical">
                    <Form.Item label="Email" required>
                        <Input
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter Email"
                        />
                        {errors.email && <div style={{ color: "red" }}>{errors.email}</div>}
                    </Form.Item>
                    <Form.Item label="Password" required>
                        <Input
                            name="Password"
                            value={formData.Password}
                            onChange={handleChange}
                            placeholder="Enter Password"
                        />
                        {errors.Password && <div style={{ color: "red" }}>{errors.Password}</div>}
                    </Form.Item>
                    <Form.Item label="Description">
                        <Input.TextArea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            placeholder="Enter Description"
                            rows={3}
                        />
                        {errors.description && (
                            <div style={{ color: "red" }}>{errors.description}</div>
                        )}
                    </Form.Item>
                    <Form.Item label="Status" required>
                        <Select
                            value={formData.status}
                            onChange={handleStatusChange}
                            options={[
                                { label: "Active", value: "active" },
                                { label: "Inactive", value: "inactive" },
                            ]}
                        />
                        {errors.status && <div style={{ color: "red" }}>{errors.status}</div>}
                    </Form.Item>
                    <div className="text-center mt-4">
                        <Button type="primary" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </div>
                </Form>
            </Drawer>

            {/* /Add Assets */}

            <DeleteModal1
                isVisible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onConfirm={() =>
                    selectedRowData?.Id &&  handleDeleteRole(selectedRowData.Id)
                }
            />
            <style>
                {`
  .role-input-box {
    border: 1px solid #8c8c8c !important; 
    border-radius: 4px;
    background-color: #fff !important;     
    color: #000;
    box-shadow: none !important;
    outline: none !important;
  }
  .role-input-status {
    background-color: #fff !important;     
    color: #000;
    box-shadow: none !important;
    outline: none !important;
  }

  .role-input-box:focus,
  .role-input-box:focus-within {
    border-color: #8c8c8c !important;    
    box-shadow: none !important;           
    background-color: #fff !important;     
  }

  /* Optional: remove default focus outline for consistency */
  .role-input-box:focus-visible {
    outline: none !important;
  }
`}
            </style>



        </>
    );
};

export default Email_confriguration;
